function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 27,
  fill: "#FFFBED"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10 11)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 22,
  x: 13,
  y: 8,
  fill: "#F5A1BD"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 15,
  x: 23,
  y: 15,
  fill: "#5C4B72"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 30,
  x: 3,
  fill: "#357495"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  x2: 33.5,
  y1: 30.5,
  y2: 30.5,
  stroke: "#0C5860",
  strokeLinecap: "square"
})));

function SvgDataanalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataanalysis);
export default __webpack_public_path__ + "static/media/dataanalysis.98367bee.svg";
export { ForwardRef as ReactComponent };